import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from "rxjs/Observable";
@Injectable()

export class RoleGuardService implements CanActivate {
    constructor(public router: Router) { }

    canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
        // this will be passed from the route config
        // on the data property
        var userRoleVal = localStorage.getItem('RoleVal');
        var roleVal = parseInt(userRoleVal);
        const expectedRole = route.data.expectedRole;
        if ((roleVal & expectedRole) !== roleVal) {
            this.router.navigate(['login']);
        }
        return true;
    }
}



// WEBPACK FOOTER //
// ./src/app/security/role-guard.service.ts